<template>
  <div>
    <h1>Отчеты для 1C</h1>
    <button class="open-modal-btn" @click="openModal">Выгрузить отчет для 1С</button>

    <div v-if="showModal" class="modal">
      <div class="modal-content">
        <h2>Выберите месяц и год</h2>
        <form @submit.prevent="handleSubmit">
          <div class="form-group">
            <label for="kato">Населенный пункт: <span class="required-sign">*</span></label>
            <multiselect
                v-model="kato"
                :options="katoList"
                :searchable="true"
                :closeOnSelect="true"
                track-by="code"
                :custom-label="formattedKatoLabel"
                placeholder="Выберите населенный пункт"
                :multiple="false"
                :clear-on-select="true"
            />
          </div>
          <div class="form-group">
            <label for="accountingMonth">Месяц: <span class="required-sign">*</span></label>
            <input
                type="number"
                id="accountingMonth"
                v-model="accountingMonth"
                min="1"
                max="12"
                required
            />
          </div>

          <div class="form-group">
            <label for="accountingYear">Год: <span class="required-sign">*</span></label>
            <input
                type="number"
                id="accountingYear"
                v-model="accountingYear"
                min="2000"
                required
            />
          </div>

          <div class="form-group">
            <label for="approveDate">Дата утверждения АВР:</label>
            <input
                type="date"
                id="approveDate"
                v-model="approveDate"
            />
          </div>

          <button type="submit" class="submit-btn" :disabled="isLoading">
            {{ isLoading ? 'Выгружается...' : 'Выгрузить' }}
          </button>
        </form>
        <button class="close-modal-btn" @click="closeModal">Закрыть</button>
      </div>
    </div>


  </div>
  <vue-loading :active.sync="isLoading" :is-full-page="true"></vue-loading>
</template>

<script lang="ts">
import {defineComponent, onMounted, ref} from "vue";
import { generate1CReport } from "@/services/reportService";
import { Generate1CReportAsyncRequest} from "@/types/report";
import VueLoading from "vue-loading-overlay";
import Multiselect from "vue-multiselect";
import cacheService from "@/services/cacheService";
import {Kato} from "@/types/kindergarten";

export default defineComponent({
  components: {Multiselect, VueLoading},
  setup() {
    const showModal = ref(false);
    const accountingMonth = ref<number>(new Date().getMonth() + 1);
    const accountingYear = ref<number>(new Date().getFullYear());
    const approveDate = ref<Date | null>(null);
    const isLoading = ref(false);
    const params = ref<Generate1CReportAsyncRequest>();
    const katoList = ref<Kato[]>([]);
    const kato = ref<Kato | null>(null);

    const fetchCachedDatas = async () => {
      katoList.value = await cacheService.useKatoStore().fetchKato();
    };

    const openModal = () => {
      showModal.value = true;
    };

    const closeModal = () => {
      showModal.value = false;
    };

    const handleSubmit = async () => {
      isLoading.value = true;

      try {
        if (accountingMonth.value !== undefined && accountingYear.value !== undefined && kato.value !== null) {
          const params = new Generate1CReportAsyncRequest(accountingMonth.value, accountingYear.value, approveDate.value, kato.value.code);
          isLoading.value = true;
          await generate1CReport(params).then(() => {
            closeModal();
            isLoading.value = false;
          });
        }
      } catch (error) {
        console.error("Ошибка при выгрузке отчета:", error);
      } finally {
        isLoading.value = false;
      }
    };

    const translateStatus = (status: string): string => {
      switch (status) {
        case "GENERATING":
          return "Файл в процессе";
        case "GENERATED":
          return "Файл создан";
        case "ERROR":
          return "Неизвестная ошибка";
        default:
          return "Неизвестно";
      }
    };

    onMounted(() => {
      fetchCachedDatas();
    });

    const formattedKatoLabel = (item: any) => {
      return `${item.code} | ${item.nameRu}`;
    };

    return {
      showModal,
      accountingMonth,
      accountingYear,
      approveDate,
      isLoading,
      openModal,
      closeModal,
      handleSubmit,
      translateStatus,
      params,
      formattedKatoLabel,
      kato,
      katoList
    };
  }
});
</script>

<style scoped>
h1 {
  text-align: center;
  margin-top: 20px;
}

.open-modal-btn {
  display: block;
  margin: 20px auto;
  padding: 10px 20px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.open-modal-btn:hover {
  background-color: #45a049;
}

.modal {
  display: block;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 400px;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

h2 {
  text-align: center;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
}

.form-group input {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.submit-btn {
  width: 100%;
  padding: 10px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.submit-btn:hover {
  background-color: #45a049;
}

.close-modal-btn {
  margin-top: 10px;
  width: 100%;
  padding: 10px;
  background-color: #f44336;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.close-modal-btn:hover {
  background-color: #e31b0c;
}

.reports-table th,
.reports-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

.reports-table th {
  background-color: #4caf50;
  color: white;
}

.required-sign {
  color: red;
}

</style>